import script from "./RoleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoleComponent.vue?vue&type=style&index=0&id=c4e1f29a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4e1f29a"]])

export default __exports__